export default "__VITE_ASSET__CESSA0Kt__"